
import './style.scss';
import { Avatar, Box } from "@mui/material";
import { useCallback } from "react";
import { useLanguageContext } from "../../contexts/LanguageContext";
import Languages from "../../data/Languages";
import ILanguage from '../../interfaces/ILanguage';
import Tooltip from '../Tooltip';

interface ILanguagesSelectorProps {
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

const LanguagesSelector: React.FunctionComponent<ILanguagesSelectorProps> = ({
    size = 'medium',
    className = ''
}) => {
    const { language, handleChangeLanguage, translate } = useLanguageContext();

    const _handleChangeLanguage = useCallback((language: ILanguage) => {
        handleChangeLanguage(language.value);
        // eslint-disable-next-line
    }, []);
    
    return (
        <Box className={`container-languagesselector ${className}`}>
            {
                Languages.map(l => {
                    const _className = l.value === language.value ? 'selected' : '';

                    return (
                        <Tooltip title={translate(l.text)} key={l.value} placement='bottom'>
                            <Avatar
                                src={l.icon}
                                alt={l.initials}
                                className={`avatar-language ${size} ${_className}`}
                                onClick={() => _handleChangeLanguage(l)}
                            />
                        </Tooltip>
                    );
                })
            }
        </Box>
    );
}

export default LanguagesSelector;